import {
  STOCK_DICTIONARY_FETCH_CAR_LOTS_BEGIN,
} from '../constants';

export function getDictionaryCarlots() {
  return (dispatch) => {
    dispatch({
      type: STOCK_DICTIONARY_FETCH_CAR_LOTS_BEGIN,
    })
  }
}